<template>
 
</template>

<script>

export default {
  title: "New",
  access_code: "P_FORM01",
  created() {
      this.$router.push("/FORMS/PersonalForm/request")
  }
};
</script>

<style>
</style>